import colorService from "@/services/colorService";

const actions = {
    getColors(store, params) {
        return new Promise((resolve, reject) => {
            colorService.fetchColors(params)
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
};

export default {
    namespaced: true,
    actions,
}